<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:37:58
 * @Description: 设备登记查看
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    title="设备信息查看"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="系统名称"
            prop="xfxtmc"
          >
            {{ fd.xfxtmc }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="设备名称"
            prop="xfsbmc"
          >
            {{ fd.xfsbmc }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="数量"
            prop="xfsbsl"
          >
            {{ fd.xfsbsl }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="出厂日期"
            prop="ccrq"
          >
            {{ fd.ccrq }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="合格证"
            prop="hgz"
          >
            {{ fd.hgz === 'Y'?'合格':fd.hgz === 'N'?'不合格':'' }}
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="产品型号/生产厂家"
            prop="xfsbxh"
          >
            <textarea-read
              v-model="fd.xfsbxh"
              class="c-form__read u-line-20"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="符合法定市场准入规则的证明文件"
            prop="xfsbzmwj"
          >
            <textarea-read
              v-model="fd.xfsbzmwj"
              class="c-form__read u-line-20"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="备注"
            prop="bz"
          >
            <textarea-read
              v-model="fd.bz"
              class="c-form__read u-line-20"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { xfsbService } from './xfsb.service';
export default {
  name: 'JcsbViewDialog',
  props: {
    xmId: {
      type: String,
      default: ''
    },
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示
      sbList: [], // 设备名称列表

      /* 表单参数 Start */
      fd: {
        xfsbmc: null, // 系统名称
        sbMc: null, // 设备名称
        xfsbsl: 0, // 数量
        ccrq: null, // 出厂日期
        hgz: null, // 合格证
        xfsbxh: null, // 产品型号/生产厂家
        xfsbzmwj: null, // 符合法定市场准入规则的证明文件
        bz: null // 备注
      }
      /* 表单参数 End */

    };
  },
  computed: {

  },
  methods: { /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },

    /**
     * @description: 获取详情
     * @return {*}
     */
    getInfo () {
      const _this = this;
      _this.loading = true;

      xfsbService.getXfsbDetail(_this.dlParams.id)
        .then(rsp => {
          this.fd = rsp.data;
        })
        .catch(err => {
          console.error('获取设备详情错误！', err);
          this.loading = false;
        }).finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.getInfo();
  }
};
</script>
